import { ButtonBase, delayedLoopCall, ingenuity, dispatcher } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { EventConstants } from "@quest/platform-murka";
import { EventConstantsLeander } from "@quest/oddsworks-platform";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { TopBarViewGame } from "./TopBarViewGame";

export class TopBarControllerGame {
    protected view: TopBarViewGame;
    protected hours: number;
    protected minutes: number;
    protected second: number;
    protected time: string;
    protected soundOn: ButtonBase;
    protected soundOff: ButtonBase;
    protected homeButton: ButtonBase;
    protected onFullScreen: ButtonBase;
    protected offFullScreen: ButtonBase;

    constructor(view: TopBarViewGame) {
        this.view = view;
        this.startclockUpdateDelay();
        this.initializeElements();
        this.subscribeEvents();
        this.bindEvents()
    }

    protected initializeElements(): void {
        this.soundOn = this.view.getButtonById("playSoundButton") as ButtonBase;
        this.soundOff = this.view.getButtonById("muteSoundButton") as ButtonBase;
        this.homeButton = this.view.getButtonById("homeButton") as ButtonBase;
        this.onFullScreen = this.view.getButtonById("enableFullScreenButton") as ButtonBase;
        this.offFullScreen = this.view.getButtonById("disableFullScreenButton") as ButtonBase;
        this.handleHomeButtonVisibilty();
    }
    protected subscribeEvents(): void {
        this.handleHomeButtonVisibilty();
        dispatcher.on(SlotEventConstantsBehavior.UPDATE_SOUND_STATE, this.updateSoundButtonStatus, this);
        dispatcher.on(SlotEventConstantsBehavior.HANDLE_HOME_BUTTON, this.handleHomeButtonVisibilty, this);
        dispatcher.on(eventDispatchers.FULL_SCREEN_GAME, this.onEnableFullScreen, this);
        dispatcher.on(eventDispatchers.DISABLE_FULL_SCREEN_GAME, this.onDisableFullScreen, this);
        dispatcher.on(eventDispatchers.SHOW_TOP_BAR, this.view.showView, this.view);
        dispatcher.on(eventDispatchers.ADD_TOP_BAR_ON_TOP, this.view.addViewOnTop, this.view);


    }
    protected bindEvents() {
        this.soundOn.on(ButtonBase.UP, this.turnOffSoundPressUp, this);
        this.soundOff.on(ButtonBase.UP, this.turnOnSoundPressUp, this);
        this.homeButton.on(ButtonBase.UP, this.onHomeBtnPressedUp, this);
        if (!ingenuity.deviceEnv.isDesktop && (ingenuity.deviceEnv.getIsIpad() || ingenuity.deviceEnv.getDeviceOS() !== 'ios')) {
            // alert("ipad--" + ingenuity.deviceEnv.getIsIpad() +"--Os--"+ ingenuity.deviceEnv.getDeviceOS() +"--ratio--" +ingenuity.deviceEnv.getAspectRatiio().toFixed(2))
            this.onFullScreen.on(ButtonBase.UP, this.onEnableFullScreen, this);
            this.offFullScreen.on(ButtonBase.UP, this.onDisableFullScreen, this);
            this.onFullScreen.visible = true;
        }
    }
    /**
 * to shift towards lobby
 */
    protected onHomeBtnPressedUp() {
        dispatcher.fireEvent(EventConstants.GO_TO_LOBBY);
    }
    /**
     * to show home button as pr activation from lobby
     */
    protected handleHomeButtonVisibilty() {
        if (!(ingenuity.parserModel as GameParserModel).getIsLobbyActive()) {
            this.homeButton.visible = false;
        }
        else {
            this.homeButton.visible = true;
        }
    }
    /**
     * This method updates the clock in evey 1000 MS delay time
     */
    protected startclockUpdateDelay() {
        delayedLoopCall(SlotConstantsBehavior.CLOCK_UP_DATE_DELAY, SlotConstantsBehavior.CLOCK_UP_DATE_DELAY_DURATION, () => {
            const timeStr = this.updateTime();
            this.view.updateClock(timeStr);
        }, this);
    }
    /**
     * This method set the current time and update the formate
     */
    protected updateTime() {
        const time = new Date();
        this.hours = time.getHours();
        // Find current hour in AM-PM Format
        //  to add 0 before minutes if is less then 10
        this.minutes = time.getMinutes();
        const minutesStr = this.minutes < 10 ? "0" + this.minutes.toString() : this.minutes.toString();
        //  to add 0 before seconds if is less then 10
        this.second = time.getSeconds();
        const secondStr = this.second < 10 ? "0" + this.second.toString() : this.second.toString();
        //  To Set AM and PM
        return this.hours.toString() + ":" + minutesStr + ":" + secondStr;
    }

    /**
     * This method will unmute the game sound and update sound status.
     */
    protected turnOffSoundPressUp() {
        ingenuity.soundManager.setMute(true);
        this.updateSoundButtonStatus();
        (ingenuity.parserModel as GameParserModel).setIsSoundMute(true);
    }
    /**
     * This method will mute the game sound and update sound status.
     */
    protected turnOnSoundPressUp() {
        ingenuity.soundManager.setMute(false);
        this.updateSoundButtonStatus();
        (ingenuity.parserModel as GameParserModel).setIsSoundMute(false);
    }
    /**
     * This method will update the console panel sound button status
    */
    protected updateSoundButtonStatus() {
        if (ingenuity.soundManager.getMute()) {
            this.soundOff.visible = true;
            this.soundOn.visible = false;
        }
        else {
            this.soundOff.visible = false;
            this.soundOn.visible = true;
        }
        dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_SOUND_STATUS_TO_WRAPPER, !ingenuity.soundManager.getMute());
    }

    protected onEnableFullScreen(): void {
        this.onFullScreen.visible = false;
        this.offFullScreen.visible = true;
        dispatcher.fireEvent(EventConstantsLeander.FULL_SCREEN_MODE_ON_OFF, true);
        dispatcher.fireEvent(eventDispatchers.RESIZE_CANVAS);
    }
    protected onDisableFullScreen(): void {
        this.onFullScreen.visible = true;
        this.offFullScreen.visible = false;
        dispatcher.fireEvent(EventConstantsLeander.FULL_SCREEN_MODE_ON_OFF, false);
        dispatcher.fireEvent(eventDispatchers.RESIZE_CANVAS);
    }
}